<template>
        <el-container style="height: 100%;">
            <el-header class="app-title">
            <img src="@/assets/images/logo.jpeg" style="float: left;">
            <div style="text-align: center; display: inline-block;" v-if="getName">
              <el-button class="date-picker-button" type="text" @click="changeDateClick(-1)" :disabled="beforeDisabled()"><i class="el-icon-arrow-left"></i></el-button>
              <el-date-picker
                class="date-picker"
                style="width: 180px; font-size: 20px;"
                v-model="selectMonth"
                type="month"
                placeholder="选择月"
                size="small"
                :editable="false"
                :clearable="false"
                ref="datePickerRef"
                align="center"
                format="yyyy 年 MM 月"
                prefix-icon="el-icon-empty"
                :picker-options = "pickerOptions"
                @change="handleSelectMonth">
              </el-date-picker>
              <el-button class="date-picker-button" type="text" @click="changeDateClick(1)" :disabled="nextDisabled()"><i class="el-icon-arrow-right"></i></el-button>
            </div>
            <div style="float: right;" class="top-nav" v-if="getName">
              <el-dropdown split-button @command="handleRoleNav">
                <span class="el-dropdown-link">
                  <!-- {{roleName[getRole]}} -->
                  {{getRoleName(getRole)}}
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="role in getRoles" :key="role" :command="role">
                    {{getRoleName(role)}}
                    <!-- {{roleName[role]}} -->
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown split-button @command="handleTopNav">
                <span class="el-dropdown-link">
                  {{getName}}
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="logout">退出</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            </el-header>
              <el-container>
              <el-aside v-if="getName" class="app-aside">
                <el-menu :default-active='$route.path' router class="sidebar" :default-openeds="['/statistics']">
                  <div v-for="item in sideBarList.filter(item => (item.roles.length === 0 || item.roles.findIndex(role => role === getRole) !== -1))" :key="item.index">
                      <el-submenu v-if="item.hasOwnProperty('child')" :index="item.index" style="padding:0">
                        <template slot="title">{{item.title}}</template>
                        <el-menu-item
                          v-for=" subitem in item['child'].filter(subitem => (subitem.roles.length === 0 || subitem.roles.findIndex(role => role === getRole) !== -1))" :key="subitem.index" :index="subitem.index" style="padding:0">
                          <template slot="title">{{subitem.title}}</template>
                        </el-menu-item>
                      </el-submenu>
                      <el-menu-item v-else
                        :key="item.index" :index="item.index" style="padding:0">
                        <template slot="title">{{item.title}}</template>
                      </el-menu-item>
                  </div>
                  <el-menu-item index=""><el-link :underline="false" href="https://meideng.yuque.com/books/share/675cf55a-84a4-4c24-acb8-8f0d6641e396" target="_blank">操作手册</el-link></el-menu-item>
                </el-menu>
              </el-aside>
              <el-main style="overflow: inherit;" class="top-main-div">
                    <div class="mainer">
                      <div class="app-inner">
                        <keep-alive>
                          <router-view v-if="$route.meta.keepAlive && isRouterAlive"></router-view>
                        </keep-alive>
                        <router-view v-if="!$route.meta.keepAlive && isRouterAlive"></router-view>
                      </div>
                    </div>
                  </el-main>
            </el-container>
        </el-container>
</template>

<script>

import '@/assets/css/base.less'
import common from '@/common/common'
import request from '@/mixins/request.js'
import routerConfig from '@/router/config'
import store from '@/store/store'
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'

export default {
  mixins: [request],
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      sideBarList: [],
      selectMonth: dayjs(this.getSelectMonth),
      isRouterAlive: true,
      pickerOptions: {
        disabledDate (time) {
          return (dayjs(time) > dayjs().endOf('month').add(1, 'month')) || dayjs(time) < dayjs('2020-12-01', 'YYYY-MM-DD')
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      getName: 'getName',
      getRole: 'getRole',
      getRoles: 'getRoles',
      isAdmin: 'isAdmin',
      isScheduler: 'isScheduler',
      isFollower: 'isFollower',
      isStreamerAdmin: 'isStreamerAdmin',
      isFollowerAdmin: 'isFollowerAdmin',
      isTreasurer: 'isTreasurer',
      getSelectMonth: 'getSelectMonth',
      isAdminStatus: 'isAdminStatus'
    }),
    roleName: function () {
      return common.RoleName
    }
  },
  methods: {
    getRoleName (role) {
      // console.log(`getRoleName ${role} ${this.isAdminStatus}`)
      if (role == 2) {
        if (this.isAdminStatus) {
          return 'SAE';
        }
      }
      return common.RoleName[role];
    },
    getUserInfo () {
      this.requestPost('user/getInfo', {'role': this.getRole}, data => {
        store.commit('set_user', data)
      })
    },
    handleTopNav (command) {
      if (command === 'logout') {
        this.logout()
      }
    },
    handleRoleNav (command) {
      if (command === this.getRole) {
        return
      }
      this.requestPost('user/getInfo', {'role': command}, data => {
        store.commit('set_user', data)
        if ([1, 2, 3].includes(this.getRole)) {
          this.$router.push({
            path: '/schedule'
          })
        } else {
          this.$router.push({
            path: '/account'
          })
        }
      })
    },
    logout () {
      this.requestPost('user/logout', {}, data => {
        store.commit('delete_user')
        this.$router.push({
          path: '/login'
        })
      })
    },
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    handleSelectMonth (value) {
      store.commit('set_range_time', this.selectMonth)
      this.getUserInfo()
      this.reload()
    },
    changeDateClick (add) {
      let max = 2
      if (dayjs().year() === 2024 && [1].includes(dayjs().month())) {
        max = 2
      }
      if (!(dayjs(this.selectMonth).add(add, 'month') < dayjs().endOf('month').add(max, 'month'))) {
        return
      }
      this.selectMonth = dayjs(this.selectMonth).add(add, 'month')
      store.commit('set_range_time', this.selectMonth)
      this.getUserInfo()
      this.reload()
    },
    nextDisabled () {
      let max = 2
      // if (dayjs().year() === 2024 && [1].includes(dayjs().month())) {
      //   max = 2
      // }
      return dayjs(this.selectMonth).year() === dayjs().endOf('month').add(max, 'month').year() &&
        dayjs(this.selectMonth).month() === dayjs().endOf('month').add(max, 'month').month()
    },
    beforeDisabled () {
      return dayjs(this.selectMonth) <= dayjs('2020-12-01', 'YYYY-MM-DD')
    }
  },
  created () {
    // console.log(this.getSelectMonth)
    this.selectMonth = dayjs(this.getSelectMonth)
    this.getUserInfo()
    this.sideBarList = routerConfig.siderBar
  },
  activated () {
    this.selectMonth = dayjs(this.getSelectMonth)
    // console.log(this.selectMonth)
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-submenu .el-menu-item {
  min-width: 180px;
}
.date-picker-button {
  display: inline-block;
  font-size: 20px;
  color:#606266;
  :hover {
    color: #1D8FFF;
  }
}
.date-picker /deep/ .el-input__inner {
  border: 0px;
}
</style>



// WEBPACK FOOTER //
// src/AppLogin.vue